import { Donut } from "@/pages/catalogs/models/Donut";
import { MenuOptionType } from "@dexteel/mesf-core";
import { DeleteSweep } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import ContentCopyIcon from "@mui/icons-material/FileCopy";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";

type Props = {
	setSelectedRowData: (donut: Donut) => void;
	setShowModal: (
		modal:
			| "create"
			| "update"
			| "delete"
			| "deleteMultiple"
			| "confirmRollsetDeactivation"
			| "activeCarrier"
			| "",
	) => void;
};
export const useDonutOptionsFunctions = ({
	setSelectedRowData,
	setShowModal,
}: Props) => {
	const getMenuOptions = (data: Donut | any) => {
		let options: MenuOptionType[] = [];
		options = options.concat([
			{
				name: "New Donut",
				key: "new_donut",
				onClick: () => {
					setShowModal("create");
				},
				icon: <PlaylistAddIcon />,
			},
		]);
		if (data) {
			const needsRollsetConfirmation =
				data.IsInActiveRollset && !data.IsInActiveCarrier;

			options = options.concat([
				{
					name: "Edit Donut",
					key: "edit_donut",
					onClick: () => {
						setSelectedRowData(data);
						setShowModal("update");
					},
					icon: <EditIcon />,
				},
				{
					name: "Delete Donut",
					key: "delete_donut",
					onClick: () => {
						setSelectedRowData(data);
						if (data.IsInActiveCarrier) {
							setShowModal("activeCarrier");
						} else if (needsRollsetConfirmation) {
							setShowModal("confirmRollsetDeactivation");
						} else {
							setShowModal("delete");
						}
					},
					icon: <DeleteIcon />,
				},
				...(data.selectedRows?.length > 1
					? [
							{
								name: `Delete selected (${data.selectedRows.length})`,
								key: "delete_selected_donuts",
								onClick: () => {
									setShowModal("deleteMultiple");
								},
								icon: <DeleteSweep />,
							},
						]
					: []),
				{
					name: "Duplicate Donut",
					key: "duplicate_donut",
					onClick: () => {
						setSelectedRowData({
							...data,
							PartName: `${data.PartName} (Copy)`,
							RFIDTag: null,
							IsDuplicate: true,
						});
						setShowModal("create");
					},
					icon: <ContentCopyIcon />,
				},
			]);
		}
		return options;
	};
	return {
		getMenuOptions,
	};
};
